import { render, staticRenderFns } from "./InPendingMaterials.vue?vue&type=template&id=05aa71c5&scoped=true"
import script from "./InPendingMaterials.vue?vue&type=script&lang=js"
export * from "./InPendingMaterials.vue?vue&type=script&lang=js"
import style0 from "./InPendingMaterials.vue?vue&type=style&index=0&id=05aa71c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05aa71c5",
  null
  
)

export default component.exports